/**
 * The validity a request that starts an agent turn needs from its bearer. The
 * agent keeps forwarding the caller's platform JWT to MCP servers for the whole
 * turn, so a token that only clears the ordinary 2-minute skew can expire while
 * the turn is still calling tools. Five minutes covers a typical turn and still
 * leaves a renewal failure room to be retried before the token is actually dead.
 * Passed to `ensureFreshPlatformJwt` by every request that starts a turn.
 */
export const AGENT_TURN_MIN_VALIDITY_MS = 300_000;
